/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import styles from '../../EnvImpairment/envImpairment.module.scss'
import metadata from './CoveredLocationsComponent.metadata.json5';

import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function CoveredLocationsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('CoveredLocationsComponent');
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            } else if(changedPath === 'actAdrsPublicID' && value !== 'new'){
                setIsEditAddress(false)
            }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountAddressOfLocRisk.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);

    const setIsEditButton = () => {
        setActAddress(modelVM.accountAddressOfLocRisk.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        } else {
            modelVM.accountAddressOfLocRisk.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountAddressOfLocRisk.value, 'accountAddressOfLocRisk')
    };

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountAddressOfLocRisk,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            AddressComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

CoveredLocationsComponent.propTypes = wizardProps;
export default withRouter(CoveredLocationsComponent);
